// 메일 인증

import { useMutation } from "@tanstack/react-query";
import { joinMailAuthApi } from "components/api/member";
import { apifield } from "components/utils/comm";
import { useLocation, useNavigate } from "react-router-dom";
import useAlertStore from "store/alert";

export const useAuthEmailMutate = () => {
  const navigate = useNavigate();
  // const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { search } = useLocation();
  return useMutation({
    mutationKey: ["join-email-auth"],
    mutationFn: joinMailAuthApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          navigate("/join/regi", {
            state: {
              certEncParam: search.replace("?param=", ""),
            },
          });
        }

        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};
